import { render, staticRenderFns } from "./TicketHistory.vue?vue&type=template&id=260de5bf&scoped=true"
import script from "./TicketHistory.vue?vue&type=script&lang=js"
export * from "./TicketHistory.vue?vue&type=script&lang=js"
import style0 from "./TicketHistory.vue?vue&type=style&index=0&id=260de5bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260de5bf",
  null
  
)

export default component.exports